import React from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Radio } from '@mui/material';

const radioSx = { color: 'var(--theme-text-secondary)' };

const TableRadioButtons = ({tableDensityValue, handleDensityChange}) => {
  // Fix: Use the prop directly with proper fallback
  const currentValue = tableDensityValue || 'comfortable';

  return (
    <FormControl>
      <RadioGroup
        row
        value={currentValue}
        name="table-density-radio-group"
        style={{alignItems: "left", color: 'var(--theme-text)'}}
        onChange={handleDensityChange}
      >
        <FormControlLabel value="spacious" control={<Radio sx={radioSx} />} label="Spacious" />
        <FormControlLabel value="comfortable" control={<Radio sx={radioSx} />} label="Comfortable" />
        <FormControlLabel value="compact" control={<Radio sx={radioSx} />} label="Compact" />
      </RadioGroup>
    </FormControl>
  );
};

export default TableRadioButtons;